import { render } from "./BusinessMenu.vue?vue&type=template&id=315b9a19"
import script from "./BusinessMenu.vue?vue&type=script&lang=js"
export * from "./BusinessMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__